import { render, staticRenderFns } from "./WhoToFollow.vue?vue&type=template&id=660b82d2&"
import script from "./WhoToFollow.vue?vue&type=script&lang=js&"
export * from "./WhoToFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports